module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon9.d7c23cda.png";